module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"notifications":{"popup":{"mark_all_as_read":"Alle als gelesen markieren","see_all":"Alle ansehen","show_only_unread":"Nur ungelesene","title":"Mitteilungen","settings_button":"Einstellungen"}}}}}}')
  delete Component.options._Ctor
}
